module.exports = __webpack_public_path__ + "static/media/SellerboxGuidePage.c58676e2.png";